module.exports = __webpack_public_path__ + "static/media/icon_noProduct.33a89fa7.svg";